import { SxProps } from "@mui/material";

export const sxRating: SxProps = {
    '& .MuiRating-iconFilled': {
        color: '#00995D',
    },
}

export const sxTitle: SxProps = {
    color: '#383838',
    fontWeight: 700,
    fontSize: '20px',
    fontFamily: "UnimedSans-Bold",
}

export const sxText: SxProps = {
    color: 'var(--grey-dark-dark, #4C4C4C)',
    fontSize: '14px',
}

